// extracted by mini-css-extract-plugin
export default {"ApiDefinition":"ApiDefinition108aSKGiQAej"};